import { Link } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import StockTicker from "./StockTicker";

const todayLabel = () => {
  const d = new Date();
  return d.toLocaleDateString("es-MX", {
    weekday: "long", year: "numeric", month: "long", day: "numeric",
  }).toUpperCase();
};

export default function Header() {
  const { user } = useAuth();
  const isAdmin = user && user.role === "admin";

  return (
    <header className="bg-paper" data-testid="site-header">
      {/* Top utility row */}
      <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-12 py-2 flex items-center justify-between text-[11px] font-mono uppercase tracking-widest text-sub">
        <span data-testid="header-date">{todayLabel()}</span>
        <span className="hidden md:inline">CIUDAD DE MÉXICO · POLÍTICA NACIONAL</span>
        <div className="flex items-center gap-3">
          {isAdmin ? (
            <Link to="/admin" className="hover:text-ink" data-testid="nav-link-admin">PANEL</Link>
          ) : (
            <Link to="/login" className="hover:text-ink" data-testid="nav-link-login">EDITORES</Link>
          )}
        </div>
      </div>

      {/* Masthead */}
      <div className="border-y-[3px] border-double border-ink">
        <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-12 py-6 sm:py-8 flex justify-center">
          <Link to="/" data-testid="brand-link" className="flex flex-col items-center">
            <img
              src="/logo-politicareal.png"
              alt="POLÍTICA REAL"
              className="h-32 sm:h-40 lg:h-48 w-auto select-none"
              draggable="false"
              decoding="async"
            />
            <p className="mt-2 text-center text-[11px] font-mono uppercase tracking-[0.35em] text-sub">
              El pulso diario de la política mexicana
            </p>
          </Link>
        </div>
      </div>

      {/* Stock ticker (replaces former secondary nav) */}
      <StockTicker />
    </header>
  );
}
